export const environment = {
  production: true,
  enableDebugLogs: true,
  enableDebugDialog: true,
  aiTemplateAnsweringEnabled: true,
  newsletterEnabled: false,
  enableUserlane: true,
  requireStagingAuth: false,
  stagingAuth: {
    username: 'admin',
    password: 'z9$(1dJ@:0tT',
  },
  directusUrl: 'https://app-cat.selecthor.io/directus-gateway',
  keycloak: {
    enable: true,
    url: 'https://app-cat.selecthor.io/auth', //Keycloak URL
    postLogoutRedirectUri: 'https://app-cat.selecthor.io/start', //Frontend URL - redirect after logout
    realm: 'Selecthor',
    clientId: 'selecthor-frontend',
  },
};
